import React from 'react';
import { graphql } from 'gatsby';
import Layout from '../components/Layout';
import CaseStudyBanner from '../components/CaseStudyBanner';
import SalesforceExplainerNav from '../components/SalesforceExplainerNav';
import ModularBlocks from '../components/ModularBlocks';
import CapabilitiesLearnMore from '../components/CapabilitiesLearnMore';
import ContactForm from '../components/ContactForm';

const SalesforceExplainerDetailPageTemplate = ({
  data: {
    datoCmsSalesforceExplainer,
    datoCmsSalesforceExplainerListing,
    allDatoCmsSalesforceExplainer: { nodes },
  },
}) => {
  const {
    seoMetaTags,
    title,
    slug,
    bannerImage,
    summary,
    modularBlocks,
    capabilities,
    capabilitiesText,
    learnMoreLinksText,
    learnMoreLinks,
  } = datoCmsSalesforceExplainer;

  return (
    <Layout seo={seoMetaTags} page={datoCmsSalesforceExplainer}>
      <main>
        <CaseStudyBanner
          heading={title}
          text={summary}
          image={bannerImage}
          isSalesforceExplainer={true}
        />
        <SalesforceExplainerNav
          link={datoCmsSalesforceExplainerListing}
          currentPage={slug}
          items={nodes}
        />
        <ModularBlocks
          items={modularBlocks}
          isSalesforceExplainerDetail={true}
        />
        <CapabilitiesLearnMore
          capabilities={capabilities}
          capabilitiesText={capabilitiesText}
          learnMoreLinksText={learnMoreLinksText}
          learnMoreLinks={learnMoreLinks}
        />
      </main>
      <ContactForm />
    </Layout>
  );
};

export const SalesforceExplainerDetailPageTemplateQuery = graphql`
  query SalesforceExplainerDetailPageTemplateQuery($id: String!) {
    datoCmsSalesforceExplainer(id: { eq: $id }) {
      seoMetaTags {
        ...GatsbyDatoCmsSeoMetaTags
      }
      title
      slug
      bannerImage {
        gatsbyImageData(width: 810, height: 740)
        alt
      }
      summary
      modularBlocks {
        ...ContainedImageNarrowerModularBlockFragment
        ...ContentModularBlockFragment
        ...ExternalVideoModularBlockFragment
        ...InternalVideoModularBlockFragment
      }
      capabilities
      capabilitiesText
      learnMoreLinksText
      learnMoreLinks {
        text
        pageUrl {
          ...LinkFragment
        }
      }
      position
      ...LinkFragment
    }
    datoCmsSalesforceExplainerListing {
      ...LinkFragment
    }
    allDatoCmsSalesforceExplainer(sort: { position: ASC }) {
      nodes {
        title
        ...LinkFragment
      }
    }
  }
`;

export default SalesforceExplainerDetailPageTemplate;
